<template>
    <div class="v-tab-body">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'VTabBody'
}
</script>

<style lang="scss" scoped>
.v-tab-body {
    padding-top: 10px;
}
</style>
